import React from 'react';
import { Colors as C } from '../../constants/Colors.js';
import {
  BUYER_PARTNER_DELIVERY_MODES,
  emptyBuyerShippingAddress,
} from '../constants/transactionLogistics.js';

const FIELD_HINT_STYLE = {
  fontSize: 9.5,
  color: 'rgba(255,255,255,0.38)',
  lineHeight: 1.45,
  marginTop: 5,
};

const inputStyle = {
  width: '100%',
  padding: '9px 11px',
  borderRadius: 9,
  border: '0.5px solid rgba(255,255,255,0.14)',
  background: 'rgba(255,255,255,0.06)',
  color: '#fff',
  fontSize: 12,
  outline: 'none',
  fontFamily: 'inherit',
  boxSizing: 'border-box',
};

function Field({ label, value, onChange, placeholder, required }) {
  return (
    <div style={{ marginBottom: 8 }}>
      <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.5)', marginBottom: 4 }}>
        {label}
        {required ? <span style={{ color: C.warn }}> *</span> : null}
      </div>
      <input
        style={inputStyle}
        value={value}
        placeholder={placeholder}
        onChange={e => onChange(e.target.value)}
        onFocus={e => {
          e.target.style.borderColor = C.gold;
        }}
        onBlur={e => {
          e.target.style.borderColor = 'rgba(255,255,255,0.14)';
        }}
      />
    </div>
  );
}

/**
 * Modalidad comprador (recogida vs envío) + dirección si aplica.
 */
export default function BuyerPartnerDeliveryFields({
  buyerDeliveryMode,
  onBuyerDeliveryModeChange,
  shippingAddress,
  onShippingAddressChange,
  showShipOption = true,
  showPickupOption = true,
}) {
  const addr = shippingAddress ?? emptyBuyerShippingAddress();
  const setAddr = patch => onShippingAddressChange?.({ ...addr, ...patch });

  return (
    <div style={{ marginTop: 10 }}>
      <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.5)', marginBottom: 6, fontWeight: 600 }}>
        ¿Cómo quieres recibir el disco desde el partner?
      </div>
      <div style={{ ...FIELD_HINT_STYLE, marginTop: 0, marginBottom: 8 }}>
        Solo verás partners que ofrecen la modalidad elegida.
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {showPickupOption ? (
          <button
            type="button"
            onClick={() => onBuyerDeliveryModeChange?.('pickup_at_partner')}
            style={{
              textAlign: 'left',
              padding: '10px 12px',
              borderRadius: 10,
              border: `0.5px solid ${
                buyerDeliveryMode === 'pickup_at_partner' ? 'rgba(200,168,75,0.55)' : 'rgba(255,255,255,0.12)'
              }`,
              background:
                buyerDeliveryMode === 'pickup_at_partner' ? 'rgba(200,168,75,0.1)' : 'rgba(0,0,0,0.2)',
              cursor: 'pointer',
            }}
          >
            <div style={{ fontSize: 12, fontWeight: 600, color: buyerDeliveryMode === 'pickup_at_partner' ? C.gold : '#fff' }}>
              {BUYER_PARTNER_DELIVERY_MODES.pickup_at_partner.label}
            </div>
            <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.42)', marginTop: 3 }}>
              {BUYER_PARTNER_DELIVERY_MODES.pickup_at_partner.desc}
            </div>
          </button>
        ) : null}
        {showShipOption ? (
          <button
            type="button"
            onClick={() => onBuyerDeliveryModeChange?.('ship_to_buyer')}
            style={{
              textAlign: 'left',
              padding: '10px 12px',
              borderRadius: 10,
              border: `0.5px solid ${
                buyerDeliveryMode === 'ship_to_buyer' ? 'rgba(200,168,75,0.55)' : 'rgba(255,255,255,0.12)'
              }`,
              background: buyerDeliveryMode === 'ship_to_buyer' ? 'rgba(200,168,75,0.1)' : 'rgba(0,0,0,0.2)',
              cursor: 'pointer',
            }}
          >
            <div style={{ fontSize: 12, fontWeight: 600, color: buyerDeliveryMode === 'ship_to_buyer' ? C.gold : '#fff' }}>
              {BUYER_PARTNER_DELIVERY_MODES.ship_to_buyer.label}
            </div>
            <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.42)', marginTop: 3 }}>
              {BUYER_PARTNER_DELIVERY_MODES.ship_to_buyer.desc}
            </div>
          </button>
        ) : null}
        {!showPickupOption && !showShipOption ? (
          <div style={{ ...FIELD_HINT_STYLE, color: C.warn }}>
            Ningún partner de la lista ofrece recogida ni envío al comprador. Prueba otra forma de entrega.
          </div>
        ) : null}
      </div>

      {buyerDeliveryMode === 'ship_to_buyer' ? (
        <div style={{ marginTop: 12, paddingTop: 10, borderTop: '0.5px solid rgba(255,255,255,0.08)' }}>
          <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.5)', marginBottom: 8, fontWeight: 600 }}>
            Dirección de envío
          </div>
          <Field label="Calle y número" required value={addr.line1} onChange={v => setAddr({ line1: v })} placeholder="Calle, nº, piso…" />
          <Field label="Línea 2 (opcional)" value={addr.line2} onChange={v => setAddr({ line2: v })} placeholder="Escalera, puerta…" />
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
            <Field label="Ciudad" required value={addr.city} onChange={v => setAddr({ city: v })} />
            <Field label="Código postal" required value={addr.postal_code} onChange={v => setAddr({ postal_code: v })} />
          </div>
          <Field label="Provincia" value={addr.province} onChange={v => setAddr({ province: v })} />
          <Field label="País" value={addr.country} onChange={v => setAddr({ country: v })} />
        </div>
      ) : null}
    </div>
  );
}
